var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaugeArcDotted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 151.834,
    height: 74.3771,
    viewBox: "0 0 151.834 74.3771",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 529",
    d: "M151.254 73.7973C151.249 73.611 151.243 73.4247 151.236 73.2385M0.579766 73.7203C0.585278 73.5339 0.591479 73.3477 0.598367 73.1615M2.27986 59.8778C2.3593 59.5138 2.44141 59.1505 2.52618 58.788M6.72121 46.0724C6.86884 45.7305 7.01901 45.3897 7.17169 45.05M13.7239 33.3729C13.9342 33.0657 14.1469 32.76 14.3619 32.4557M23.0296 22.2501C23.1624 22.1194 23.2956 21.9891 23.4294 21.8593C23.5632 21.7294 23.6975 21.6001 23.8321 21.4714M34.2938 13.1145C34.6044 12.9088 34.9164 12.7054 35.2298 12.5045M47.0986 6.30638C47.4428 6.16398 47.788 6.02414 48.1342 5.88686M60.9702 2.07618C61.3351 2.00235 61.7007 1.93121 62.0669 1.86275M75.3951 0.581556C75.5814 0.580271 75.7678 0.579675 75.9543 0.579771C76.1407 0.579866 76.3271 0.580652 76.5134 0.582128M89.8403 1.87695C90.2065 1.94578 90.5719 2.0173 90.9368 2.09151M103.769 5.91531C104.115 6.05294 104.46 6.19314 104.804 6.33589M116.666 12.5461C116.98 12.7474 117.291 12.9511 117.602 13.1571M128.055 21.5247C128.19 21.6536 128.324 21.783 128.457 21.913C128.591 22.0429 128.724 22.1734 128.857 22.3042M137.514 32.5187C137.729 32.8232 137.941 33.1291 138.151 33.4365M144.691 45.1203C144.844 45.4601 144.993 45.8011 145.141 46.1432M149.323 58.8631C149.407 59.2257 149.489 59.589 149.568 59.9531",
    strokeWidth: 1.15952,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FF6551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeArcDotted);
export default __webpack_public_path__ + "static/media/gauge-arc-dotted.b66343d05876cabdbd89698e5d4f262b.svg";
export { ForwardRef as ReactComponent };